import ReactCodeInput, { ReactCodeInputProps } from "react-code-input";
import styled from "styled-components";

import { inputBaseStyles } from "../Input/styles";
import { StyledInputProps } from "../Input/types";

export const CodeInput = styled<
  React.FC<ReactCodeInputProps & StyledInputProps>
>(
  ReactCodeInput as unknown as React.FC<ReactCodeInputProps & StyledInputProps>
)`
  display: flex !important;
  justify-content: space-between;

  input {
    width: 2.5rem;
    height: 2.5rem;
    text-align: center;
    -moz-appearance: textfield;

    ${inputBaseStyles}
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
